import { useState, useCallback } from "react";
import { isEqual } from "lodash";

import { IncomingMailStatusQuickFilter } from "./interfaces";
import { IncomingMailStatusDTO } from "src/models/incoming-mail-status/incoming-mail-status-dto";
import { IncomingMailStatusRef } from "src/models/incoming-mail-status/incoming-mail-status-ref";

export const useIncomingMailStatusQuickFilter = (defaultValue?: IncomingMailStatusRef[]) => {
  const [quickFilter, setQuickFilter] = useState<IncomingMailStatusQuickFilter>({
    incomingMailStatuses: {
      incomingMailStatusIds: defaultValue ? [...defaultValue.map((item) => item.id)] : [],
    },
  });

  const [selectedIncomingMailStatus, setSelectedIncomingMailStatus] = useState<IncomingMailStatusRef | null>(
    defaultValue ? defaultValue[0] : null
  );

  const handleChangeQuickFilter = useCallback(
    (
      filter: keyof IncomingMailStatusQuickFilter,
      value: IncomingMailStatusQuickFilter["incomingMailStatuses"],
      item: IncomingMailStatusDTO | null
    ) => {
      if (isEqual(value, quickFilter[filter])) return;

      setQuickFilter((state) => ({ ...state, [filter]: value }));
      setSelectedIncomingMailStatus(item);

      localStorage.setItem("QF_IMS", JSON.stringify(value));
    },
    [quickFilter]
  );

  return {
    incomingMailStatusQuickFilter: quickFilter,
    setIncomingMailStatusQuickFilter: handleChangeQuickFilter,
    selectedIncomingMailStatus: selectedIncomingMailStatus,
  };
};
